import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import SVG from "../../SVGs/LandingSVG";

import Button from "../../components/button";

import OnLine from "../../SVGs/onLine";
import Reports from "../../SVGs/reports";

import IMG1 from "../../images/1.png";
import IMG3 from "../../images/2.png";
import IMG2 from "../../images/3.png";
import Responsev from "../../images/responsev.png";

import { Carousel } from "antd";
import { useSelector } from "react-redux";

export default function App() {
  const { t } = useTranslation();
  const mode = useSelector((state) => state.mode);

  const downloadFiles = () => {
    window.open("https://almonazim.com/المنظم.apk", "_blank"); // فتح الرابط الأول
    //  console.log(1)
    //     // إضافة تأخير قبل فتح الرابط الثاني
    //     setTimeout(() => {
    //        window.open("https://almonazim.com/المنظم_فواتير.apk", '_blank'); // فتح الرابط الثاني
    //        console.log(2)
    //     }, 4000);
  };

  return (
    <Container>
      <Row className="justify-center">
        <Col lg={4} md={6} sm={12} className="landing-text-top">
          <div>
            <h1 className="text-5xl font-bold main_color ">
              {t("AL_MONAZZEM")}
            </h1>
            <p className="text-2xl pt-4 font-bold">{t("text_landing_1")}</p>
            <p className="text-xl pb-4">
              {/* {t("text_landing_2")} */}
              {t("text_landing_2")}
            </p>
            <div>
              <Button href="#Contact_us" text={t("download_app_now")} />
            </div>
          </div>
        </Col>
        <Col lg={8} md={6} sm={12} className="flex justify-center">
          <SVG />
        </Col>
      </Row>
      <Row className={"justify-center py-5 " + mode + "_svg"}>
        <Col lg={4} md={10} sm={12} className="py-3">
          <div className="landing-card">
            <p className="text-start px-3">
              <div className="text-2xl">{t("l_c_1")}</div>
              <div>{t("l_c_1_text")}</div>
            </p>
            <p>
              <OnLine />
            </p>
          </div>
        </Col>
        <Col lg={4} md={10} sm={12} className="py-3">
          <div className="landing-card">
            <p className="text-start px-3">
              <div className="text-2xl">{t("l_c_2")}</div>
              <div>{t("l_c_2_text")}</div>
            </p>
            <p>
              <Reports />
            </p>
          </div>
        </Col>
        <Col lg={4} md={10} sm={12} className="py-3">
          <div className="landing-card">
            <p className="text-start px-3">
              <div className="text-2xl font-bold">{t("l_c_3")}</div>
              <div>{t("l_c_3_text")}</div>
            </p>
            <div className="d-flex justify-content-center align-items-center py-4">
              {/* Custom Price Update SVG Icon */}
              <svg
                width="80"
                height="80"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.4853 3 16.7353 4.00736 18.364 5.63604M18.364 5.63604L15 6M18.364 5.63604V2"
                  stroke="#1f1f1f"
                  strokeWidth="1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 10L12.5 13.5L15 11"
                  stroke="#1f1f1f"
                  strokeWidth="1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7 15H17"
                  stroke="#1f1f1f"
                  strokeWidth="1"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="justify-center py-5 ">
        <p className="text-4xl font-bold main_color pb-5 ">
          {" "}
          {t("text_access")}{" "}
        </p>

        <img className="responsev_img" src={Responsev} />
        <p className="text-xl font-bold"> {t("can_use")} </p>
        <p className="text-xl font-bold pb-5"> {t("just_sign_in")} </p>
        <hr className="hr-index" />
      </Row>

      <Row className="justify-center py-10 pb-24">
        <Col lg={12} xs={12} className="phone-none">
          <Carousel dotPosition={"right"} autoplay className="Ar">
            <div>
              <Container>
                <Row className="justify-center">
                  <Col lg={5} md={6} className="landing-text-down">
                    <div>
                      <h1 className="text-4xl font-bold main_color ">
                        {t("phone_4")}
                      </h1>
                      <p className="text-2xl pt-4 ">{t("text_phone_4")}</p>
                    </div>
                  </Col>
                  <Col lg={5} md={6} className="flex justify-center">
                    <img src={IMG2} />
                  </Col>
                </Row>
              </Container>
            </div>
            <div>
              <Container>
                <Row className="justify-center">
                  <Col lg={5} md={6} className="flex justify-center">
                    <img src={IMG3} />
                  </Col>
                  <Col lg={5} md={6} className="landing-text-down">
                    <div>
                      <h1 className="text-4xl font-bold main_color ">
                        {t("phone_3")}
                      </h1>
                      <p className="text-2xl pt-4 ">{t("text_phone_3")}</p>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
            <div>
              <Container>
                <Row className="justify-center">
                  <Col lg={5} md={6} className="landing-text-down">
                    <div>
                      <h1 className="text-4xl font-bold main_color ">
                        {t("phone_2")}
                      </h1>
                      <p className="text-2xl pt-4 ">{t("text_phone_2")}</p>
                    </div>
                  </Col>
                  <Col lg={5} md={6} className="flex justify-center">
                    <img src={IMG2} />
                  </Col>
                </Row>
              </Container>
            </div>

            <div>
              <Container>
                <Row className="justify-center">
                  <Col lg={5} md={6} className="flex justify-center">
                    <img src={IMG1} />
                  </Col>
                  <Col lg={5} md={6} className="landing-text-down">
                    <div>
                      <h1 className="text-4xl font-bold main_color ">
                        {t("phone_1")}
                      </h1>
                      <p className="text-2xl pt-4 ">{t("text_phone_1")}</p>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </Carousel>
        </Col>
        <Col className="laptop-none" lg={12} sm={12}>
          <div className="pt-3">
            <Row className="justify-center">
              <Col lg={5} md={6} className="landing-text-down">
                <div>
                  <h1 className="text-2xl font-bold main_color ">
                    {t("phone_4")}
                  </h1>
                  <p className="text-xl py-4 ">{t("text_phone_4")}</p>
                </div>
              </Col>
              <Col lg={5} md={6} className="flex justify-center">
                <img src={IMG2} />
              </Col>
            </Row>
          </div>
          <hr className="m-10" />
          <div className="pt-3">
            <Row className="justify-center">
              <Col lg={5} md={6} className="landing-text-down">
                <div>
                  <h1 className="text-2xl font-bold main_color ">
                    {t("phone_3")}
                  </h1>
                  <p className="text-xl py-4 ">{t("text_phone_3")}</p>
                </div>
              </Col>
              <Col lg={5} md={6} className="flex justify-center">
                <img src={IMG3} />
              </Col>
            </Row>
          </div>
          <hr className="m-10" />
          <div>
            <Row className="justify-center">
              <Col lg={5} md={6} className="landing-text-down">
                <div>
                  <h1 className="text-2xl font-bold main_color ">
                    {t("phone_2")}
                  </h1>
                  <p className="text-xl py-4 ">{t("text_phone_2")}</p>
                </div>
              </Col>
              <Col lg={5} md={6} className="flex justify-center">
                <img src={IMG2} />
              </Col>
            </Row>
          </div>

          <hr className="m-10" />
          <div>
            <Row className="justify-center">
              <Col lg={5} md={6} className="landing-text-down">
                <div>
                  <h1 className="text-2xl font-bold main_color ">
                    {t("phone_1")}
                  </h1>
                  <p className="text-xl py-4 ">{t("text_phone_1")}</p>
                </div>
              </Col>
              <Col lg={5} md={6} className="flex justify-center">
                <img src={IMG1} />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
